import { CompanyProfile } from '@mkp/company/models';
import { AccountMembership } from '@mkp/account-membership/models';
import { Account } from '@mkp/account/models';
import { LegalEntityDto } from '@mkp/legal-entity/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export type OnboardingRecoveryStep =
  'account' | 'membership' | 'wallet' | 'companyProfile' | 'location';

export const authActions = createActionGroup({
  source: 'Auth',
  events: {
    'App Bootstrapped': emptyProps(),
    'App Bootstrap Failed': props<{ error: string }>(),
    'Unverified User Authenticated': emptyProps(),
    'Verified User Authenticated': props<{ userId: string }>(),
    'No Accounts Found After User Login': emptyProps(),
    'Load Legal Entity For User With No Account Failed': emptyProps(),
    'Fetched Accounts After Login': props<{ accounts: Account[] }>(),
    'No Memberships Found After Login': props<{ accounts: Account[] }>(),
    'No Wallets Found After Login': props<{ accountIds: Account['id'][] }>(),
    'No Companies Found After Login': props<{ accountMemberships: AccountMembership[] }>(),
    'Load Active Account Memberships Success': props<{
      accountMemberships: AccountMembership[];
      totalCount: number;
    }>(),
    'Load Active Account Memberships Failed': props<{ error: { message: string } }>(),
    'Load Accounts After Login Success': props<{ accounts: Account[] }>(),
    'Load Accounts After BO Login Success': props<{ accounts: Account[] }>(),
    'Load Accounts After Login Failed': props<{ error: { message: string } }>(),
    'Load Companies After Login Success': props<{ companyProfiles: CompanyProfile[] }>(),
    'Load Companies After Login Failed': props<{ error: { message: string } }>(),
    'Load Wallets After Login Success': emptyProps(),
    'Load Wallets After Login Failed': props<{ error: { message: string } }>(),
    'Workspace Select Page Entered': emptyProps(),
    'Workspace Selected': props<{
      accountId: Account['id'];
      companyProfileId: string;
      accountMembershipId: string;
    }>(),
    'Initialize the User': emptyProps(),
    'Workspace Found in Store': props<{ accounts: Account[] }>(),
    'Load Workspace Account Success': props<{ accounts: Account[] }>(),
    'Load Workspace Account Error': props<{ error: { message: string }; status: number }>(),
    'Load Workspace Company Success': props<{ companyProfiles: CompanyProfile[] }>(),
    'Load Workspace Company Error': props<{ error: { message: string } }>(),
  },
});

export const authOnboardingRecoveryActions = createActionGroup({
  source: 'Auth Recovery',
  events: {
    'Onboarding Failed From Account': props<{ legalEntityDto: LegalEntityDto }>(),
    'Onboarding Failed From Membership': props<{ account: Account }>(),
    'Onboarding Failed From Wallet': props<{ accountIds: Account['id'][] }>(),
    'Onboarding Failed From Company': props<{ accountIds: Account['id'][] }>(),
    'Onboarding Failed From Location': props<{ companyProfiles: CompanyProfile[] }>(),
    'Onboarding Recovery Success': props<{ step: OnboardingRecoveryStep }>(),
    'Onboarding Recovery Failed': emptyProps(),
  },
});

export const boAuthActions = createActionGroup({
  source: 'Bo Auth',
  events: {
    'Workspace Unselected': props<Pick<Account, 'legalEntityId'>>(),
    'Load Workspace': props<{ accountId: Account['id'] }>(),
    'Load Workspace Error': props<{ error: { message: string } }>(),
  },
});

export const authWorkspaceActions = createActionGroup({
  source: 'Auth Workspace',
  events: {
    'Workspace Selection Required': emptyProps(),
    'Workspace Selection Not Required': emptyProps(),
    'Unguarded Route': emptyProps(),
  },
});

export const authWorkspaceGuardActions = createActionGroup({
  source: 'Auth Workspace Guard',
  events: {
    'Workspace Selected From Url Resource': props<{ accountId: string }>(),
    'Redirected On No Selected Workspace': emptyProps(),
    'Workspace Selection Not Required': emptyProps(),
  },
});
